import { IconDotGrid1x3Vertical } from 'central-icons/IconDotGrid1x3Vertical';
import type { ReactNode } from 'react';

import { IconButton, Menu, MenuButton, MenuList } from '@revelio/ui';

import styles from './param-item-menu.module.css';

export const ParamItemMenu = ({ children }: { children: ReactNode }) => (
  <Menu>
    <MenuButton>
      <IconButton
        icon={<IconDotGrid1x3Vertical size={14} />}
        size="md"
        shape="rounded"
        aria-label="Actions"
        variant="ghost"
        className={styles.menuTrigger}
        onClick={(e) => {
          e.stopPropagation();
        }}
      />
    </MenuButton>
    <MenuList align="end">{children}</MenuList>
  </Menu>
);
